var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Wrapper',{attrs:{"type":_vm.type,"size":_vm.size,"disabled":_vm.disable,"shadow":_vm.shadow},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{class:{ text: _vm.loading }},[_vm._v(_vm._s(_vm.title))]),_c('span',{class:{ spinner: _vm.loading }})])
}
var staticRenderFns = []

export { render, staticRenderFns }